// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_scqq-","maskContent":"index_maskContent_LmEkQ"};